import { render, staticRenderFns } from "./AnnotationItem.vue?vue&type=template&id=269acb5a&scoped=true"
import script from "./AnnotationItem.vue?vue&type=script&lang=js"
export * from "./AnnotationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269acb5a",
  null
  
)

export default component.exports